export const DEFAULT_MODULE_TYPE_LABELS: Record<string, string> = {
  biography: 'Biografie',
  contact_info: 'Kontaktinfo',
  socials: 'Socials',
  links: 'Links',
  video: 'Video',
  images: 'Bilder',
  files: 'Dateien',
  google_maps: 'Standort',
  team_members: 'Teammitglieder',
};

export const MODULE_TYPE_DEFAULT_HEADINGS: Record<string, readonly string[]> = {
  biography: ['Biografie', 'Biography'],
  contact_info: ['Kontaktinfo', 'Contact info'],
  socials: ['Socials'],
  links: ['Links'],
  video: ['Video'],
  images: ['Bilder', 'Images'],
  files: ['Dateien', 'Files'],
  google_maps: ['Standort', 'Location'],
  team_members: ['Teammitglieder', 'Team members'],
};

export type PublicProfileModuleChrome = {
  teamSearchPlaceholder: string;
  teamSearchAria: string;
  teamEmpty: string;
  previous: string;
  next: string;
  previousImage: string;
  nextImage: string;
  imageAltFallback: string;
  fileFallback: string;
  download: string;
  zoomIn: string;
  zoomOut: string;
  mapUnavailable: string;
};

const DEFAULT_CHROME: PublicProfileModuleChrome = {
  teamSearchPlaceholder: 'Teammitglieder suchen...',
  teamSearchAria: 'Teammitglieder suchen',
  teamEmpty: 'Keine Teammitglieder gefunden.',
  previous: 'Vorherige',
  next: 'Nächste',
  previousImage: 'Vorheriges Bild',
  nextImage: 'Nächstes Bild',
  imageAltFallback: 'Bild {n}',
  fileFallback: 'Datei',
  download: 'Download',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  mapUnavailable: 'Map unavailable',
};

function asString(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim() !== '' ? value : fallback;
}

export function resolvePublicProfileModuleChrome(
  modules: unknown,
): PublicProfileModuleChrome {
  const record =
    modules && typeof modules === 'object'
      ? (modules as Record<string, unknown>)
      : {};
  return {
    teamSearchPlaceholder: asString(
      record.teamSearchPlaceholder,
      DEFAULT_CHROME.teamSearchPlaceholder,
    ),
    teamSearchAria: asString(
      record.teamSearchAria,
      DEFAULT_CHROME.teamSearchAria,
    ),
    teamEmpty: asString(record.teamEmpty, DEFAULT_CHROME.teamEmpty),
    previous: asString(record.previous, DEFAULT_CHROME.previous),
    next: asString(record.next, DEFAULT_CHROME.next),
    previousImage: asString(record.previousImage, DEFAULT_CHROME.previousImage),
    nextImage: asString(record.nextImage, DEFAULT_CHROME.nextImage),
    imageAltFallback: asString(
      record.imageAltFallback,
      DEFAULT_CHROME.imageAltFallback,
    ),
    fileFallback: asString(record.fileFallback, DEFAULT_CHROME.fileFallback),
    download: asString(record.download, DEFAULT_CHROME.download),
    zoomIn: asString(record.zoomIn, DEFAULT_CHROME.zoomIn),
    zoomOut: asString(record.zoomOut, DEFAULT_CHROME.zoomOut),
    mapUnavailable: asString(
      record.mapUnavailable,
      DEFAULT_CHROME.mapUnavailable,
    ),
  };
}

export function resolvePublicProfileModuleTypeLabels(
  modules: unknown,
): Record<string, string> {
  const record =
    modules && typeof modules === 'object'
      ? (modules as Record<string, unknown>)
      : {};
  const types =
    record.types && typeof record.types === 'object'
      ? (record.types as Record<string, unknown>)
      : {};
  const labels: Record<string, string> = { ...DEFAULT_MODULE_TYPE_LABELS };
  for (const [key, value] of Object.entries(types)) {
    if (typeof value === 'string' && value.trim()) {
      labels[key] = value.trim();
    }
  }
  return labels;
}

export function formatImageAlt(template: string, index: number): string {
  return template.replaceAll('{n}', String(index));
}
